import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportes-ingresos',
  templateUrl: './reportes-ingresos.component.html',
  styleUrls: ['./reportes-ingresos.component.scss']
})
export class ReportesIngresosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
